export default "__VITE_ASSET__C5S_Cli3__"